import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getSite = async (
  token: string,
  baseUrl: string,
  params?: any,
  config?: any
) => {
  const queryPath = `${baseUrl}/site`;
  try {
    const res = await get(token, queryPath, params, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
